import { TIME_RANGE_VALUES } from 'hooks/useTimeRange/consts'

export const TYPE_TO_KEY = {
  subtopic: 'subtopics',
  topic: 'topics',
  niche: 'niches',
  saved_search: 'savedPostSearches',
  industry_topic: 'industry_topic',
  global_topic: 'global_topic',
  trending: 'trendings',
  tag: 'tags',
  SavedPostSearch: 'savedPostSearches',
} as const

export const TYPE_MAPPING = {
  topic: { entityType: 'topic', selectedType: TYPE_TO_KEY.topic },
  industry_topic: { entityType: 'industry_topic', selectedType: TYPE_TO_KEY.industry_topic },
  global_topic: { entityType: 'global_topic', selectedType: TYPE_TO_KEY.global_topic },
  subtopic: { entityType: 'subtopic', selectedType: TYPE_TO_KEY.subtopic },
  savedSearch: { entityType: 'saved_search', selectedType: TYPE_TO_KEY.saved_search },
  niche: { entityType: 'niche', selectedType: TYPE_TO_KEY.niche },
  trending: { entityType: 'trending', selectedType: TYPE_TO_KEY.trending },
  tag: { entityType: 'tag', selectedType: TYPE_TO_KEY.tag },
} as const

export const TERRITORY_TYPENAMES = {
  Subtopic: 'subtopic',
  Topic: 'topic',
  Niche: 'niche',
  IndustryTopic: 'industry_topic',
  GlobalTopic: 'global_topic',
  SavedPostSearch: 'savedSearch',
  Trending: 'trending',
  TerritoryTag: 'tag',
} as const

export const DEFAULT_TERRITORY_DATE = TIME_RANGE_VALUES['30d']

export const DAY_INTERVALS = ['0', '7', '1', '24h', 'today']
